// Sorting functionality
const SORT = {
  BUTTON_SELECTOR: '.facets-sort',
  CLOSE_BUTTON_SELECTOR: '.sort-dropdown-close',
  DROPDOWN_SELECTOR: '.sort-dropdown',
  LINK_SELECTOR: '.sort-dropdown-link'
};

// Get sorting elements
const sortDropdown = document.querySelector(SORT.DROPDOWN_SELECTOR);
const sortButton = document.querySelector(SORT.BUTTON_SELECTOR);
const sortCloseButton = document.querySelector(SORT.CLOSE_BUTTON_SELECTOR);

// Function to disable and enable scroll
function disableScroll() {
  document.body.classList.add('no-scroll');
}

function enableScroll() {
  document.body.classList.remove('no-scroll');
}

// Function to toggle the sort dropdown
function toggleSortDropdown() {
  if (sortDropdown) {
    const isOpen = sortDropdown.toggleAttribute('open');
    isOpen ? disableScroll() : enableScroll();
  }
}

// Event listener for the sort dropdown
document.addEventListener('click', (e) => {
  const target = e.target;
  const isSortButton = target === sortButton || target.closest(SORT.BUTTON_SELECTOR);
  const isSortCloseButton = target === sortCloseButton || target.closest(SORT.CLOSE_BUTTON_SELECTOR);
  const isSortDropdown = target.matches(SORT.DROPDOWN_SELECTOR);

  if (isSortButton || isSortCloseButton || isSortDropdown) {
    toggleSortDropdown();
  }
});

// Initialize sort links
document.addEventListener('DOMContentLoaded', () => {
  const sortLinks = document.querySelectorAll(SORT.LINK_SELECTOR);
  const urlParams = new URLSearchParams(window.location.search);
  const currentSortBy = urlParams.get('sort_by');

  if (sortLinks.length) {
    sortLinks.forEach((link) => {
      const sortValue = link.getAttribute('data-sort');

      // Add the selected class to the current sort value
      if (sortValue == currentSortBy) {
        link.classList.add('sort-selected');
      }

      // Event listener for the sort dropdown
      link.addEventListener('click', (e) => {
        const sortValue = e.target.getAttribute('data-sort');
        if (!sortValue) return;

        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortValue);
        window.location.href = url.toString();
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Handle option button hover effects
  document.querySelectorAll('.option-button').forEach(button => {
    button.addEventListener('mouseenter', function () {
      const variantImage = this.getAttribute('data-variant-image');
      if (!variantImage) return;

      const cardWrapper = this.closest('.card-wrapper');
      if (!cardWrapper) return;

      const mediaContainer = cardWrapper.querySelector('.card__media .media');
      if (!mediaContainer) return;

      // Hide existing images
      const existingImages = mediaContainer.querySelectorAll('img');
      existingImages.forEach(img => img.style.display = 'none');

      // Create and add variant image
      const variantImg = document.createElement('img');
      variantImg.className = 'variant-image';
      variantImg.src = variantImage;
      variantImg.alt = 'Product variant';

      // Copy size attributes from first original image
      if (existingImages[0]) {
        variantImg.width = existingImages[0].width;
        variantImg.height = existingImages[0].height;
      }

      mediaContainer.appendChild(variantImg);
    });

    button.addEventListener('mouseleave', function () {
      const cardWrapper = this.closest('.card-wrapper');
      if (!cardWrapper) return;

      const mediaContainer = cardWrapper.querySelector('.card__media .media');
      if (!mediaContainer) return;

      // Remove variant image
      const variantImage = mediaContainer.querySelector('.variant-image');
      if (variantImage) {
        variantImage.remove();
      }

      // Show original images
      const originalImages = mediaContainer.querySelectorAll('img:not(.variant-image)');
      originalImages.forEach(img => img.style.display = '');
    });
  });

  // Handle custom select dropdowns
  document.querySelectorAll('.select-variant-mobile').forEach(select => {
    const summaryText = select.querySelector('.summary-text');
    const optionButtons = select.querySelectorAll('.option-button');
    const originalText = summaryText.textContent;

    optionButtons.forEach(button => {
      button.addEventListener('click', function (e) {
        // Close the details element
        select.removeAttribute('open');
      });
    });
  });

  // Handle change price when hover to option button
  document.querySelectorAll('.option-item').forEach(option => {
    option.addEventListener('mouseenter', function () {
      const $productWrapper = this.closest('.product-card-wrapper');
      const $productPrice = $productWrapper.querySelector('.price');
      const $variantPrice = this.querySelector('.price-variant');

      if (!$variantPrice) return;

      const $cloneVariantPrice = $variantPrice.cloneNode(true);

      $cloneVariantPrice.classList.add('cloned-price');

      $cloneVariantPrice.classList.add('hidden');
      $productPrice.after($cloneVariantPrice);

      // Get and set height before switching visibility
      const priceHeight = $productPrice.offsetHeight + 'px';
      $cloneVariantPrice.style.height = priceHeight;

      $productPrice.classList.add('hidden');
      $cloneVariantPrice.classList.remove('hidden');
    });

    option.addEventListener('mouseleave', function () {
      const $productWrapper = this.closest('.product-card-wrapper');
      const $priceElement = $productWrapper.querySelector('.price:not(.price-variant)');
      const $clonedPriceElement = $productWrapper.querySelector('.cloned-price');

      $clonedPriceElement.remove();
      $priceElement.classList.remove('hidden');
    });
  });
});
